export default "__VITE_ASSET__Dm_cOunC__"